<template>
  <targeting-info-checkbox
    fieldName="allowOpenMarketTargeting"
    :label="$t('allow.targeting.checkbox.label')"
    :popover="$t('allow.targeting.checkbox.popover')"
  />
</template>

<script>
import TargetingInfoCheckbox from './TargetingInfoCheckbox.vue';

export default {
  components: {
    TargetingInfoCheckbox,
  },
};
</script>